import EntryLists from '@/pages/entry-lists/EntryLists';

export default EntryLists;
